import { Component, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tooltip-content" [ngClass]="position">
      <ng-content></ng-content>
      <span class="tooltip-arrow" [ngClass]="position"></span>
    </div>
  `,
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() visible = false;

  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  @HostBinding('class.visible') get hostVisible() {
    return this.visible;
  }
}
